<template>
  <v-dialog v-model="open" max-width="700px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-card width="100%" class="rounded-0">
        <v-row justify="space-between" no-gutters>
          <v-col cols="11" v-bind="attrs" v-on="on" v-ripple class="pa-4">
            <p class="text-subtitle-2 my-0">Adicionar seção e itens</p>
          </v-col>
        </v-row>
      </v-card>
    </template>

    <v-card>
      <v-card-title>Adicionar seção do menu</v-card-title>

      <v-card-text>
        <v-form
            @submit="e => e.preventDefault()"
            ref="form"
            v-model="formValid"
            lazy-validation
        >
          <v-row no-gutters>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
                  label="Nome da seção"
                  v-model="formData.title"
                  :rules="sectionTitleRules"
                  required
                  dense
                  outlined
                  :counter="140"
                  v-on:keypress="keyPress"
              ></v-text-field>
            </v-col>
          </v-row>

          <p style="color: black" class="text-body-1 text--black mb-0">Adicionar item do menu</p>

          <p>Insira pelo menos um item por seção. Você poderá adicionar mais itens futuramente.</p>

          <v-row no-gutters>
            <v-col cols="12" md="8" sm="8" xs="12" class="pr-sm-4">
              <v-text-field
                  label="Nome do item"
                  v-model="formData.item.title"
                  :rules="itemTitleRules"
                  required
                  dense
                  outlined
                  :counter="140"
                  v-on:keypress="keyPress"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="4" xs="12">
              <v-text-field
                  label="Preço do item (R$)"
                  v-model="formData.item.price"
                  dense
                  outlined
                  v-mask="currencyMask"
                  v-on:keypress="keyPress"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="12">
              <v-textarea
                  rows="3"
                  auto-grow
                  label="Descrição do item"
                  v-model="formData.item.description"
                  :counter="1000"
                  :rules="descriptionRules"
                  dense
                  outlined
                  v-on:keypress="keyPress"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="secondary"
            text
            @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
            :loading="loading"
            color="primary"
            text
            @click="callAction"
        >
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
const currencyMask = createNumberMask({
  prefix: '',
  allowDecimal: true,
  includeThousandsSeparator: false,
  allowNegative: false
})

export default {
  name: "LocationMenuAddSectionModal",
  props: {
    action: {
      type: Function,
      required: true
    },
    clearOnSubmit: Boolean,
  },
  methods: {
    keyPress: function(e) {
      if (e.keyCode === 13) this.callAction()
    },
    cancel: function() {
      this.open = false
    },
    callAction: async function () {
      if (this.validate()) {
        this.loading = true
        this.formData.item.price_formatted = this.formData.item.price ? 'R$ ' + parseFloat(this.formData.item.price).toFixed(2) : ''
        await this.action(this.formData)

        if (this.clearOnSubmit) {
          this.formData = {
            title: '',
            item: {
              title: '',
              description: '',
              price: '',
              price_formatted: ''
            }
          }
        }
        this.open = false
        this.loading = false
      }
    },
    validate: function() {
      return this.$refs.form.validate()
    }
  },
  data: () => ({
    currencyMask,
    open: false,
    loading: false,
    formValid: true,
    formData: {
      title: '',
      item: {
        title: '',
        description: '',
        price: '',
        price_formatted: '',
      }
    },
    descriptionRules: [
      v => (v && v.length <= 1000 || !v) || 'A descrição pode ter no máximo 1.000 caracteres'
    ],
    sectionTitleRules: [
      v => !!v || 'O nome da seção é obrigatório',
      v => (v && v.length <= 140) || 'O nome da seção pode ter no máximo 140 caracteres',
    ],
    itemTitleRules: [
      v => !!v || 'O nome do item é obrigatório',
      v => (v && v.length <= 140) || 'O nome do item pode ter no máximo 140 caracteres',
    ]
  }),
  created() {
    this.formData = JSON.parse(JSON.stringify({
      title: '',
      item: {
        title: '',
        description: '',
        price: '',
        price_formatted: ''
      }
    }))
  }
}
</script>

<style scoped>
</style>